import React, { useState } from 'react';
import { HomeIcon, UsersIcon, SettingsIcon, SearchIcon, FileTextIcon, ListIcon, ChevronRightIcon, ChevronDownIcon, ActivityIcon, ClipboardListIcon, UserIcon, FileIcon, BuildingIcon } from 'lucide-react';
interface SidebarProps {
  collapsed: boolean;
  onToggleCollapse: () => void;
  onNavigate: (path: string) => void;
  activePath: string;
}
interface MenuItem {
  title: string;
  path: string;
  icon: React.ReactNode;
  submenu?: MenuItem[];
}
export function Sidebar({
  collapsed,
  onToggleCollapse,
  onNavigate,
  activePath
}: SidebarProps) {
  const [expandedMenus, setExpandedMenus] = useState<string[]>(['home']);
  const menuItems: MenuItem[] = [{
    title: 'Home',
    path: 'dashboard',
    icon: <HomeIcon size={20} data-id="element-149" />
  }, {
    title: 'Management',
    path: 'management',
    icon: <UsersIcon size={20} data-id="element-150" />,
    submenu: [{
      title: 'Role Management',
      path: 'management/roles',
      icon: <UserIcon size={20} data-id="element-151" />
    }, {
      title: 'User Management',
      path: 'management/users',
      icon: <UsersIcon size={20} data-id="element-152" />
    }]
  }, {
    title: 'Participants Management',
    path: 'participants/list',
    icon: <BuildingIcon size={20} data-id="element-153" />
  }, {
    title: 'Configurations',
    path: 'configurations',
    icon: <SettingsIcon size={20} data-id="element-154" />
  }, {
    title: 'Transaction Monitoring',
    path: 'transactions/monitoring',
    icon: <ActivityIcon size={20} data-id="element-155" />
  }, {
    title: 'Transaction Search',
    path: 'transactions/search',
    icon: <SearchIcon size={20} data-id="element-156" />
  }, {
    title: 'Reports',
    path: 'reports',
    icon: <FileTextIcon size={20} data-id="element-157" />,
    submenu: [{
      title: 'Transaction Report',
      path: 'reports/transactions',
      icon: <FileIcon size={20} data-id="element-158" />
    }, {
      title: 'Transaction Summary Report',
      path: 'reports/summary',
      icon: <ClipboardListIcon size={20} data-id="element-159" />
    }, {
      title: 'Users List',
      path: 'reports/users',
      icon: <ListIcon size={20} data-id="element-160" />
    }, {
      title: 'User Activity Audit Log',
      path: 'reports/user-activity',
      icon: <ActivityIcon size={20} data-id="element-161" />
    }]
  }, {
    title: 'Audit Log',
    path: 'audit-log',
    icon: <ListIcon size={20} data-id="element-162" />
  }];
  const toggleMenu = (path: string) => {
    setExpandedMenus(prev => prev.includes(path) ? prev.filter(p => p !== path) : [...prev, path]);
  };
  const handleMenuItemClick = (path: string) => {
    onNavigate(path);
  };
  const renderMenuItem = (item: MenuItem, level = 0) => {
    const isActive = activePath === item.path;
    const hasSubmenu = item.submenu && item.submenu.length > 0;
    const isExpanded = expandedMenus.includes(item.path);
    return <div key={item.path} data-id="element-163">
        <button onClick={() => hasSubmenu ? toggleMenu(item.path) : handleMenuItemClick(item.path)} className={`flex items-center w-full text-left px-4 py-2 rounded-md transition-colors ${isActive ? 'bg-[#F58220] bg-opacity-10 text-[#F58220]' : 'text-gray-700 hover:bg-gray-100'}`} style={{
        paddingLeft: `${level * 12 + 16}px`
      }} data-id="element-164">
          <span className="mr-3" data-id="element-165">{item.icon}</span>
          {!collapsed && <>
              <span className="flex-grow" data-id="element-166">{item.title}</span>
              {hasSubmenu && (isExpanded ? <ChevronDownIcon size={16} data-id="element-167" /> : <ChevronRightIcon size={16} data-id="element-168" />)}
            </>}
        </button>
        {hasSubmenu && isExpanded && !collapsed && <div className="mt-1" data-id="element-169">
            {item.submenu!.map(subItem => renderMenuItem(subItem, level + 1))}
          </div>}
      </div>;
  };
  return <aside className={`bg-white border-r border-gray-200 h-full transition-all duration-300 ${collapsed ? 'w-16' : 'w-64'}`} data-id="element-170">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-171">
        {!collapsed && <h2 className="font-semibold text-[#1A1F36]" data-id="element-172">Navigation</h2>}
        <button onClick={onToggleCollapse} className="p-1 rounded-md hover:bg-gray-100" aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} data-id="element-173">
          {collapsed ? <ChevronRightIcon size={20} data-id="element-174" /> : <ChevronDownIcon size={20} data-id="element-175" />}
        </button>
      </div>
      <nav className="p-2 space-y-1" data-id="element-176">
        {menuItems.map(item => renderMenuItem(item))}
      </nav>
    </aside>;
}